import {Component, Inject} from '@angular/core';
import {FavoriteList} from '@models/favorite';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdService} from '@services/ad.service';
import {FormService} from '@services/form.service';
import {AlertService} from '@services/alert.service';
import {OnboardingService} from '@services/onboarding.service';

@Component({
    selector: 'app-new-popup',
    templateUrl: './new-popup.component.html',
    styleUrls: ['./new-popup.component.scss']
})
export class NewPopupComponent {

    loading = false;

    favoriteForm = new UntypedFormGroup({
        title: new UntypedFormControl('', []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private adService: AdService,
        private onboardingService: OnboardingService,
        public dialogRef: MatDialogRef<NewPopupComponent>,
        public formService: FormService,
        private alertService: AlertService) {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.favoriteForm.valid && this.loading == false) {
            this.loading = true;
            if (this.favoriteForm.get('title').value) {
                const favoriteList: FavoriteList = {
                    title: this.favoriteForm.get('title').value,
                    user_id: 0,
                    favorites: [],
                    share: false,
                    owner_name: '',
                };
                this.adService.addFavoritesList(favoriteList).subscribe((listId) => {
                    this.dialogRef.close(listId);
                }, error => {
                    this.alertService.error('une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
                    console.log(error);
                    this.loading = false;
                });
            }
        }
    }

}
